import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { ReactNode, ComponentType } from "react";

interface UnlockPromptProps {
  icon: ReactNode;
  title: string;
  description: ReactNode;
  buttonText: string;
  onUnlock: () => void;
  isLoading?: boolean;
  isAbsolute?: boolean;
  buttonIcon?: ComponentType;
}

export const UnlockPrompt = ({
  icon,
  title,
  description,
  buttonText,
  onUnlock,
  isLoading = false,
  isAbsolute = true,
  buttonIcon,
}: UnlockPromptProps) => {
  const containerProps = isAbsolute
    ? {
        position: "absolute" as const,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 10,
      }
    : {};

  return (
    <Box {...containerProps}>
      <Box
        maxW="400px"
        w="fit-content"
        // bg="neutral.100"
        // backdropFilter="blur(4px)"
        rounded="2xl"
        boxShadow="themeColor.shadow.xl"
        bg="themeColor.blur.alpha600"
        p={3}
      >
        <Flex flexDir="column">
          <Flex align="center" gap={1} pb={1.5}>
            {icon}
            <Text textStyle="sm" fontWeight="bold" color="themeColor.fg.title">
              {title}
            </Text>
          </Flex>

          <Text
            textStyle="xs"
            color="themeColor.fg.body"
            textAlign="left"
            lineHeight="1.5"
            pb={4}
          >
            {description}
          </Text>

          <Flex justify="center">
            <Button
              variant="solid"
              onClick={onUnlock}
              loading={isLoading}
              w="fit-content"
              px={3}
              py={2}
              fontFamily="heading"
              fontWeight="light"
              size="sm"
            >
              {buttonIcon && <Icon as={buttonIcon} boxSize={4} />}
              {buttonText}
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
